// src/features/vhc/pages/record/vhc/index.tsx
import { VhcBlock } from './components/VhcBlock';
import { VhcBlockWrapper } from './components/VhcBlockWrapper';
import { groupNamesOrder, useVhcList } from './useVhcList';
import { VarClassEnum, VHCRecordLogDto } from 'api/generated';
import { useUpdateVhcRecordsMutation } from 'features/vhc/api/use-update-vhc-records.mutation';
import { Button } from 'react-bootstrap';
import { formatDate } from 'utils/formats';

export type VideoTabProps = {
  id?: VHCRecordLogDto['id'];
  wipNo: string;
  regNo: string;
  mileage: number;
  vin: string;
  carDescription: string;
  varclass: VarClassEnum;
  customerName: string;
  refetch?: () => void;
  dateComplete?: string | null;
  userComplete?: string | null;
};

export const VhcTab: React.FC<VideoTabProps> = (props: VideoTabProps) => {
  const { getGroupedItems, getItemInfo } = useVhcList();

  const { refetch, id, dateComplete, userComplete } = props;

  const { mutate: updateVHCRecord, isLoading: isCompleteVHCLoading } = useUpdateVhcRecordsMutation();

  const completeVHCRecord = () => {
    updateVHCRecord(
      { id: id!, requestBody: { isCompleted: true, ...props } },
      {
        onSuccess() {
          if (refetch) refetch();
        }
      }
    );
  };

  return (
    <>
      <div className="d-flex flex-column gap-4">
        {groupNamesOrder.map(({ group }) => {
          const { items, groupName } = getGroupedItems(group);

          return (
            <VhcBlockWrapper key={group} groupName={groupName}>
              <div className="d-flex flex-column gap-2">
                {items.map((item) => {
                  return (
                    <VhcBlock
                      isCompleted={Boolean(dateComplete) && Boolean(userComplete)}
                      key={`${item.id}_${item.type}_${item.group}_${item.isNew}`}
                      data={item}
                    />
                  );
                })}
              </div>
            </VhcBlockWrapper>
          );
        })}

        {dateComplete && userComplete ? (
          <div className="d-flex my-auto">
            <Button disabled style={{ width: 176, height: 38, background: '#B2B9BC' }}>
              Completed
            </Button>
            <span className="fw-semibold text-muted fs-6 ms-4 my-auto">
              Created: {dateComplete && formatDate(dateComplete, 'DD/MM/YYYY HH:MM')} - by {userComplete}{' '}
            </span>
          </div>
        ) : (
          <Button onClick={completeVHCRecord} style={{ width: 176, height: 38, background: '#CE181F' }}>
            Complete
          </Button>
        )}
      </div>
    </>
  );
};
